var $t = Object.defineProperty, _t = Object.defineProperties;
var Bt = Object.getOwnPropertyDescriptors;
var xe = Object.getOwnPropertySymbols;
var ct = Object.prototype.hasOwnProperty, lt = Object.prototype.propertyIsEnumerable;
var Le = Math.pow, st = (e, t, n) => t in e ? $t(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, C = (e, t) => {
  for (var n in t || (t = {}))
    ct.call(t, n) && st(e, n, t[n]);
  if (xe)
    for (var n of xe(t))
      lt.call(t, n) && st(e, n, t[n]);
  return e;
}, F = (e, t) => _t(e, Bt(t));
var Se = (e) => typeof e == "symbol" ? e : e + "", pe = (e, t) => {
  var n = {};
  for (var o in e)
    ct.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && xe)
    for (var o of xe(e))
      t.indexOf(o) < 0 && lt.call(e, o) && (n[o] = e[o]);
  return n;
};
var U = (e, t, n) => new Promise((o, r) => {
  var s = (u) => {
    try {
      c(n.next(u));
    } catch (f) {
      r(f);
    }
  }, i = (u) => {
    try {
      c(n.throw(u));
    } catch (f) {
      r(f);
    }
  }, c = (u) => u.done ? o(u.value) : Promise.resolve(u.value).then(s, i);
  c((n = n.apply(e, t)).next());
});
import * as p from "react";
import { useLayoutEffect as xt, useEffect as Nt, useRef as Wt } from "react";
import * as Ht from "react-dom";
function Oe() {
  return typeof window != "undefined";
}
function de(e) {
  return Rt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function j(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ee(e) {
  var t;
  return (t = (Rt(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Rt(e) {
  return Oe() ? e instanceof Node || e instanceof j(e).Node : !1;
}
function W(e) {
  return Oe() ? e instanceof Element || e instanceof j(e).Element : !1;
}
function Y(e) {
  return Oe() ? e instanceof HTMLElement || e instanceof j(e).HTMLElement : !1;
}
function He(e) {
  return !Oe() || typeof ShadowRoot == "undefined" ? !1 : e instanceof ShadowRoot || e instanceof j(e).ShadowRoot;
}
function we(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = z(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function Vt(e) {
  return ["table", "td", "th"].includes(de(e));
}
function Te(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch (n) {
      return !1;
    }
  });
}
function Ue(e) {
  const t = Me(), n = W(e) ? z(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function Kt(e) {
  let t = ne(e);
  for (; Y(t) && !se(t); ) {
    if (Ue(t))
      return t;
    if (Te(t))
      return null;
    t = ne(t);
  }
  return null;
}
function Me() {
  return typeof CSS == "undefined" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function se(e) {
  return ["html", "body", "#document"].includes(de(e));
}
function z(e) {
  return j(e).getComputedStyle(e);
}
function De(e) {
  return W(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ne(e) {
  if (de(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    He(e) && e.host || // Fallback.
    ee(e)
  );
  return He(t) ? t.host : t;
}
function bt(e) {
  const t = ne(e);
  return se(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Y(t) && we(t) ? t : bt(t);
}
function ie(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = bt(e), s = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = j(r);
  if (s) {
    const c = Ve(i);
    return t.concat(i, i.visualViewport || [], we(r) ? r : [], c && n ? ie(c) : []);
  }
  return t.concat(r, ie(r, [], n));
}
function Ve(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ut(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function ve(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && He(n)) {
    let o = t;
    for (; o; ) {
      if (e === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function Et() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function Ct() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: o
    } = t;
    return n + "/" + o;
  }).join(" ") : navigator.userAgent;
}
function jt(e) {
  return zt() ? !1 : !ft() && e.width === 0 && e.height === 0 || ft() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function Yt() {
  return /apple/i.test(navigator.vendor);
}
function ft() {
  const e = /android/i;
  return e.test(Et()) || e.test(Ct());
}
function Xt() {
  return Et().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function zt() {
  return Ct().includes("jsdom/");
}
function Ke(e, t) {
  const n = ["mouse", "pen"];
  return n.push("", void 0), n.includes(e);
}
function Ut(e) {
  return "nativeEvent" in e;
}
function Gt(e) {
  return e.matches("html,body");
}
function ce(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function Ie(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function ue(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const qt = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function Jt(e) {
  return Y(e) && e.matches(qt);
}
const q = Math.min, K = Math.max, Ce = Math.round, Re = Math.floor, Q = (e) => ({
  x: e,
  y: e
}), Qt = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Zt = {
  start: "end",
  end: "start"
};
function je(e, t, n) {
  return K(e, q(t, n));
}
function oe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function J(e) {
  return e.split("-")[0];
}
function me(e) {
  return e.split("-")[1];
}
function Ge(e) {
  return e === "x" ? "y" : "x";
}
function qe(e) {
  return e === "y" ? "height" : "width";
}
function G(e) {
  return ["top", "bottom"].includes(J(e)) ? "y" : "x";
}
function Je(e) {
  return Ge(G(e));
}
function en(e, t, n) {
  n === void 0 && (n = !1);
  const o = me(e), r = Je(e), s = qe(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = Ae(i)), [i, Ae(i)];
}
function tn(e) {
  const t = Ae(e);
  return [Ye(e), t, Ye(t)];
}
function Ye(e) {
  return e.replace(/start|end/g, (t) => Zt[t]);
}
function nn(e, t, n) {
  const o = ["left", "right"], r = ["right", "left"], s = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? r : o : t ? o : r;
    case "left":
    case "right":
      return t ? s : i;
    default:
      return [];
  }
}
function on(e, t, n, o) {
  const r = me(e);
  let s = nn(J(e), n === "start", o);
  return r && (s = s.map((i) => i + "-" + r), t && (s = s.concat(s.map(Ye)))), s;
}
function Ae(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Qt[t]);
}
function rn(e) {
  return C({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, e);
}
function Qe(e) {
  return typeof e != "number" ? rn(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ae(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function at(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const s = G(t), i = Je(t), c = qe(i), u = J(t), f = s === "y", d = o.x + o.width / 2 - r.width / 2, a = o.y + o.height / 2 - r.height / 2, m = o[c] / 2 - r[c] / 2;
  let l;
  switch (u) {
    case "top":
      l = {
        x: d,
        y: o.y - r.height
      };
      break;
    case "bottom":
      l = {
        x: d,
        y: o.y + o.height
      };
      break;
    case "right":
      l = {
        x: o.x + o.width,
        y: a
      };
      break;
    case "left":
      l = {
        x: o.x - r.width,
        y: a
      };
      break;
    default:
      l = {
        x: o.x,
        y: o.y
      };
  }
  switch (me(t)) {
    case "start":
      l[i] -= m * (n && f ? -1 : 1);
      break;
    case "end":
      l[i] += m * (n && f ? -1 : 1);
      break;
  }
  return l;
}
const sn = (e, t, n) => U(void 0, null, function* () {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: i
  } = n, c = s.filter(Boolean), u = yield i.isRTL == null ? void 0 : i.isRTL(t);
  let f = yield i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: d,
    y: a
  } = at(f, o, u), m = o, l = {}, h = 0;
  for (let g = 0; g < c.length; g++) {
    const {
      name: y,
      fn: v
    } = c[g], {
      x: b,
      y: w,
      data: E,
      reset: P
    } = yield v({
      x: d,
      y: a,
      initialPlacement: o,
      placement: m,
      strategy: r,
      middlewareData: l,
      rects: f,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = b != null ? b : d, a = w != null ? w : a, l = F(C({}, l), {
      [y]: C(C({}, l[y]), E)
    }), P && h <= 50 && (h++, typeof P == "object" && (P.placement && (m = P.placement), P.rects && (f = P.rects === !0 ? yield i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : P.rects), {
      x: d,
      y: a
    } = at(f, m, u)), g = -1);
  }
  return {
    x: d,
    y: a,
    placement: m,
    strategy: r,
    middlewareData: l
  };
});
function Ze(e, t) {
  return U(this, null, function* () {
    var n;
    t === void 0 && (t = {});
    const {
      x: o,
      y: r,
      platform: s,
      rects: i,
      elements: c,
      strategy: u
    } = e, {
      boundary: f = "clippingAncestors",
      rootBoundary: d = "viewport",
      elementContext: a = "floating",
      altBoundary: m = !1,
      padding: l = 0
    } = oe(t, e), h = Qe(l), y = c[m ? a === "floating" ? "reference" : "floating" : a], v = ae(yield s.getClippingRect({
      element: (n = yield s.isElement == null ? void 0 : s.isElement(y)) == null || n ? y : y.contextElement || (yield s.getDocumentElement == null ? void 0 : s.getDocumentElement(c.floating)),
      boundary: f,
      rootBoundary: d,
      strategy: u
    })), b = a === "floating" ? {
      x: o,
      y: r,
      width: i.floating.width,
      height: i.floating.height
    } : i.reference, w = yield s.getOffsetParent == null ? void 0 : s.getOffsetParent(c.floating), E = (yield s.isElement == null ? void 0 : s.isElement(w)) ? (yield s.getScale == null ? void 0 : s.getScale(w)) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    }, P = ae(s.convertOffsetParentRelativeRectToViewportRelativeRect ? yield s.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements: c,
      rect: b,
      offsetParent: w,
      strategy: u
    }) : b);
    return {
      top: (v.top - P.top + h.top) / E.y,
      bottom: (P.bottom - v.bottom + h.bottom) / E.y,
      left: (v.left - P.left + h.left) / E.x,
      right: (P.right - v.right + h.right) / E.x
    };
  });
}
const cn = (e) => ({
  name: "arrow",
  options: e,
  fn(n) {
    return U(this, null, function* () {
      const {
        x: o,
        y: r,
        placement: s,
        rects: i,
        platform: c,
        elements: u,
        middlewareData: f
      } = n, {
        element: d,
        padding: a = 0
      } = oe(e, n) || {};
      if (d == null)
        return {};
      const m = Qe(a), l = {
        x: o,
        y: r
      }, h = Je(s), g = qe(h), y = yield c.getDimensions(d), v = h === "y", b = v ? "top" : "left", w = v ? "bottom" : "right", E = v ? "clientHeight" : "clientWidth", P = i.reference[g] + i.reference[h] - l[h] - i.floating[g], I = l[h] - i.reference[h], S = yield c.getOffsetParent == null ? void 0 : c.getOffsetParent(d);
      let B = S ? S[E] : 0;
      (!B || !(yield c.isElement == null ? void 0 : c.isElement(S))) && (B = u.floating[E] || i.floating[g]);
      const $ = P / 2 - I / 2, H = B / 2 - y[g] / 2 - 1, L = q(m[b], H), N = q(m[w], H), k = L, _ = B - y[g] - N, O = B / 2 - y[g] / 2 + $, D = je(k, O, _), A = !f.arrow && me(s) != null && O !== D && i.reference[g] / 2 - (O < k ? L : N) - y[g] / 2 < 0, x = A ? O < k ? O - k : O - _ : 0;
      return {
        [h]: l[h] + x,
        data: C({
          [h]: D,
          centerOffset: O - D - x
        }, A && {
          alignmentOffset: x
        }),
        reset: A
      };
    });
  }
}), ln = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    fn(n) {
      return U(this, null, function* () {
        var o, r;
        const {
          placement: s,
          middlewareData: i,
          rects: c,
          initialPlacement: u,
          platform: f,
          elements: d
        } = n, O = oe(e, n), {
          mainAxis: a = !0,
          crossAxis: m = !0,
          fallbackPlacements: l,
          fallbackStrategy: h = "bestFit",
          fallbackAxisSideDirection: g = "none",
          flipAlignment: y = !0
        } = O, v = pe(O, [
          "mainAxis",
          "crossAxis",
          "fallbackPlacements",
          "fallbackStrategy",
          "fallbackAxisSideDirection",
          "flipAlignment"
        ]);
        if ((o = i.arrow) != null && o.alignmentOffset)
          return {};
        const b = J(s), w = G(u), E = J(u) === u, P = yield f.isRTL == null ? void 0 : f.isRTL(d.floating), I = l || (E || !y ? [Ae(u)] : tn(u)), S = g !== "none";
        !l && S && I.push(...on(u, y, g, P));
        const B = [u, ...I], $ = yield Ze(n, v), H = [];
        let L = ((r = i.flip) == null ? void 0 : r.overflows) || [];
        if (a && H.push($[b]), m) {
          const D = en(s, c, P);
          H.push($[D[0]], $[D[1]]);
        }
        if (L = [...L, {
          placement: s,
          overflows: H
        }], !H.every((D) => D <= 0)) {
          var N, k;
          const D = (((N = i.flip) == null ? void 0 : N.index) || 0) + 1, A = B[D];
          if (A && (!(m === "alignment" ? w !== G(A) : !1) || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          L.every((M) => M.overflows[0] > 0 && G(M.placement) === w)))
            return {
              data: {
                index: D,
                overflows: L
              },
              reset: {
                placement: A
              }
            };
          let x = (k = L.filter((R) => R.overflows[0] <= 0).sort((R, M) => R.overflows[1] - M.overflows[1])[0]) == null ? void 0 : k.placement;
          if (!x)
            switch (h) {
              case "bestFit": {
                var _;
                const R = (_ = L.filter((M) => {
                  if (S) {
                    const T = G(M.placement);
                    return T === w || // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    T === "y";
                  }
                  return !0;
                }).map((M) => [M.placement, M.overflows.filter((T) => T > 0).reduce((T, V) => T + V, 0)]).sort((M, T) => M[1] - T[1])[0]) == null ? void 0 : _[0];
                R && (x = R);
                break;
              }
              case "initialPlacement":
                x = u;
                break;
            }
          if (s !== x)
            return {
              reset: {
                placement: x
              }
            };
        }
        return {};
      });
    }
  };
};
function At(e) {
  const t = q(...e.map((s) => s.left)), n = q(...e.map((s) => s.top)), o = K(...e.map((s) => s.right)), r = K(...e.map((s) => s.bottom));
  return {
    x: t,
    y: n,
    width: o - t,
    height: r - n
  };
}
function un(e) {
  const t = e.slice().sort((r, s) => r.y - s.y), n = [];
  let o = null;
  for (let r = 0; r < t.length; r++) {
    const s = t[r];
    !o || s.y - o.y > o.height / 2 ? n.push([s]) : n[n.length - 1].push(s), o = s;
  }
  return n.map((r) => ae(At(r)));
}
const fn = function(e) {
  return e === void 0 && (e = {}), {
    name: "inline",
    options: e,
    fn(n) {
      return U(this, null, function* () {
        const {
          placement: o,
          elements: r,
          rects: s,
          platform: i,
          strategy: c
        } = n, {
          padding: u = 2,
          x: f,
          y: d
        } = oe(e, n), a = Array.from((yield i.getClientRects == null ? void 0 : i.getClientRects(r.reference)) || []), m = un(a), l = ae(At(a)), h = Qe(u);
        function g() {
          if (m.length === 2 && m[0].left > m[1].right && f != null && d != null)
            return m.find((v) => f > v.left - h.left && f < v.right + h.right && d > v.top - h.top && d < v.bottom + h.bottom) || l;
          if (m.length >= 2) {
            if (G(o) === "y") {
              const L = m[0], N = m[m.length - 1], k = J(o) === "top", _ = L.top, O = N.bottom, D = k ? L.left : N.left, A = k ? L.right : N.right, x = A - D, R = O - _;
              return {
                top: _,
                bottom: O,
                left: D,
                right: A,
                width: x,
                height: R,
                x: D,
                y: _
              };
            }
            const v = J(o) === "left", b = K(...m.map((L) => L.right)), w = q(...m.map((L) => L.left)), E = m.filter((L) => v ? L.left === w : L.right === b), P = E[0].top, I = E[E.length - 1].bottom, S = w, B = b, $ = B - S, H = I - P;
            return {
              top: P,
              bottom: I,
              left: S,
              right: B,
              width: $,
              height: H,
              x: S,
              y: P
            };
          }
          return l;
        }
        const y = yield i.getElementRects({
          reference: {
            getBoundingClientRect: g
          },
          floating: r.floating,
          strategy: c
        });
        return s.reference.x !== y.reference.x || s.reference.y !== y.reference.y || s.reference.width !== y.reference.width || s.reference.height !== y.reference.height ? {
          reset: {
            rects: y
          }
        } : {};
      });
    }
  };
};
function an(e, t) {
  return U(this, null, function* () {
    const {
      placement: n,
      platform: o,
      elements: r
    } = e, s = yield o.isRTL == null ? void 0 : o.isRTL(r.floating), i = J(n), c = me(n), u = G(n) === "y", f = ["left", "top"].includes(i) ? -1 : 1, d = s && u ? -1 : 1, a = oe(t, e);
    let {
      mainAxis: m,
      crossAxis: l,
      alignmentAxis: h
    } = typeof a == "number" ? {
      mainAxis: a,
      crossAxis: 0,
      alignmentAxis: null
    } : {
      mainAxis: a.mainAxis || 0,
      crossAxis: a.crossAxis || 0,
      alignmentAxis: a.alignmentAxis
    };
    return c && typeof h == "number" && (l = c === "end" ? h * -1 : h), u ? {
      x: l * d,
      y: m * f
    } : {
      x: m * f,
      y: l * d
    };
  });
}
const dn = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    fn(n) {
      return U(this, null, function* () {
        var o, r;
        const {
          x: s,
          y: i,
          placement: c,
          middlewareData: u
        } = n, f = yield an(n, e);
        return c === ((o = u.offset) == null ? void 0 : o.placement) && (r = u.arrow) != null && r.alignmentOffset ? {} : {
          x: s + f.x,
          y: i + f.y,
          data: F(C({}, f), {
            placement: c
          })
        };
      });
    }
  };
}, mn = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    fn(n) {
      return U(this, null, function* () {
        const {
          x: o,
          y: r,
          placement: s
        } = n, v = oe(e, n), {
          mainAxis: i = !0,
          crossAxis: c = !1,
          limiter: u = {
            fn: (b) => {
              let {
                x: w,
                y: E
              } = b;
              return {
                x: w,
                y: E
              };
            }
          }
        } = v, f = pe(v, [
          "mainAxis",
          "crossAxis",
          "limiter"
        ]), d = {
          x: o,
          y: r
        }, a = yield Ze(n, f), m = G(J(s)), l = Ge(m);
        let h = d[l], g = d[m];
        if (i) {
          const b = l === "y" ? "top" : "left", w = l === "y" ? "bottom" : "right", E = h + a[b], P = h - a[w];
          h = je(E, h, P);
        }
        if (c) {
          const b = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", E = g + a[b], P = g - a[w];
          g = je(E, g, P);
        }
        const y = u.fn(F(C({}, n), {
          [l]: h,
          [m]: g
        }));
        return F(C({}, y), {
          data: {
            x: y.x - o,
            y: y.y - r,
            enabled: {
              [l]: i,
              [m]: c
            }
          }
        });
      });
    }
  };
}, gn = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: s,
        middlewareData: i
      } = t, {
        offset: c = 0,
        mainAxis: u = !0,
        crossAxis: f = !0
      } = oe(e, t), d = {
        x: n,
        y: o
      }, a = G(r), m = Ge(a);
      let l = d[m], h = d[a];
      const g = oe(c, t), y = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : C({
        mainAxis: 0,
        crossAxis: 0
      }, g);
      if (u) {
        const w = m === "y" ? "height" : "width", E = s.reference[m] - s.floating[w] + y.mainAxis, P = s.reference[m] + s.reference[w] - y.mainAxis;
        l < E ? l = E : l > P && (l = P);
      }
      if (f) {
        var v, b;
        const w = m === "y" ? "width" : "height", E = ["top", "left"].includes(J(r)), P = s.reference[a] - s.floating[w] + (E && ((v = i.offset) == null ? void 0 : v[a]) || 0) + (E ? 0 : y.crossAxis), I = s.reference[a] + s.reference[w] + (E ? 0 : ((b = i.offset) == null ? void 0 : b[a]) || 0) - (E ? y.crossAxis : 0);
        h < P ? h = P : h > I && (h = I);
      }
      return {
        [m]: l,
        [a]: h
      };
    }
  };
}, hn = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    fn(n) {
      return U(this, null, function* () {
        var o, r;
        const {
          placement: s,
          rects: i,
          platform: c,
          elements: u
        } = n, L = oe(e, n), {
          apply: f = () => {
          }
        } = L, d = pe(L, [
          "apply"
        ]), a = yield Ze(n, d), m = J(s), l = me(s), h = G(s) === "y", {
          width: g,
          height: y
        } = i.floating;
        let v, b;
        m === "top" || m === "bottom" ? (v = m, b = l === ((yield c.isRTL == null ? void 0 : c.isRTL(u.floating)) ? "start" : "end") ? "left" : "right") : (b = m, v = l === "end" ? "top" : "bottom");
        const w = y - a.top - a.bottom, E = g - a.left - a.right, P = q(y - a[v], w), I = q(g - a[b], E), S = !n.middlewareData.shift;
        let B = P, $ = I;
        if ((o = n.middlewareData.shift) != null && o.enabled.x && ($ = E), (r = n.middlewareData.shift) != null && r.enabled.y && (B = w), S && !l) {
          const N = K(a.left, 0), k = K(a.right, 0), _ = K(a.top, 0), O = K(a.bottom, 0);
          h ? $ = g - 2 * (N !== 0 || k !== 0 ? N + k : K(a.left, a.right)) : B = y - 2 * (_ !== 0 || O !== 0 ? _ + O : K(a.top, a.bottom));
        }
        yield f(F(C({}, n), {
          availableWidth: $,
          availableHeight: B
        }));
        const H = yield c.getDimensions(u.floating);
        return g !== H.width || y !== H.height ? {
          reset: {
            rects: !0
          }
        } : {};
      });
    }
  };
};
function Pt(e) {
  const t = z(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = Y(e), s = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, c = Ce(n) !== s || Ce(o) !== i;
  return c && (n = s, o = i), {
    width: n,
    height: o,
    $: c
  };
}
function et(e) {
  return W(e) ? e : e.contextElement;
}
function fe(e) {
  const t = et(e);
  if (!Y(t))
    return Q(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: s
  } = Pt(t);
  let i = (s ? Ce(n.width) : n.width) / o, c = (s ? Ce(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: i,
    y: c
  };
}
const pn = /* @__PURE__ */ Q(0);
function Ot(e) {
  const t = j(e);
  return !Me() || !t.visualViewport ? pn : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function vn(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== j(e) ? !1 : t;
}
function le(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), s = et(e);
  let i = Q(1);
  t && (o ? W(o) && (i = fe(o)) : i = fe(e));
  const c = vn(s, n, o) ? Ot(s) : Q(0);
  let u = (r.left + c.x) / i.x, f = (r.top + c.y) / i.y, d = r.width / i.x, a = r.height / i.y;
  if (s) {
    const m = j(s), l = o && W(o) ? j(o) : o;
    let h = m, g = Ve(h);
    for (; g && o && l !== h; ) {
      const y = fe(g), v = g.getBoundingClientRect(), b = z(g), w = v.left + (g.clientLeft + parseFloat(b.paddingLeft)) * y.x, E = v.top + (g.clientTop + parseFloat(b.paddingTop)) * y.y;
      u *= y.x, f *= y.y, d *= y.x, a *= y.y, u += w, f += E, h = j(g), g = Ve(h);
    }
  }
  return ae({
    width: d,
    height: a,
    x: u,
    y: f
  });
}
function tt(e, t) {
  const n = De(e).scrollLeft;
  return t ? t.left + n : le(ee(e)).left + n;
}
function Tt(e, t, n) {
  n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), r = o.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    tt(e, o)
  )), s = o.top + t.scrollTop;
  return {
    x: r,
    y: s
  };
}
function wn(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const s = r === "fixed", i = ee(o), c = t ? Te(t.floating) : !1;
  if (o === i || c && s)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, f = Q(1);
  const d = Q(0), a = Y(o);
  if ((a || !a && !s) && ((de(o) !== "body" || we(i)) && (u = De(o)), Y(o))) {
    const l = le(o);
    f = fe(o), d.x = l.x + o.clientLeft, d.y = l.y + o.clientTop;
  }
  const m = i && !a && !s ? Tt(i, u, !0) : Q(0);
  return {
    width: n.width * f.x,
    height: n.height * f.y,
    x: n.x * f.x - u.scrollLeft * f.x + d.x + m.x,
    y: n.y * f.y - u.scrollTop * f.y + d.y + m.y
  };
}
function yn(e) {
  return Array.from(e.getClientRects());
}
function xn(e) {
  const t = ee(e), n = De(e), o = e.ownerDocument.body, r = K(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), s = K(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + tt(e);
  const c = -n.scrollTop;
  return z(o).direction === "rtl" && (i += K(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: c
  };
}
function Rn(e, t) {
  const n = j(e), o = ee(e), r = n.visualViewport;
  let s = o.clientWidth, i = o.clientHeight, c = 0, u = 0;
  if (r) {
    s = r.width, i = r.height;
    const f = Me();
    (!f || f && t === "fixed") && (c = r.offsetLeft, u = r.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: c,
    y: u
  };
}
function bn(e, t) {
  const n = le(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, s = Y(e) ? fe(e) : Q(1), i = e.clientWidth * s.x, c = e.clientHeight * s.y, u = r * s.x, f = o * s.y;
  return {
    width: i,
    height: c,
    x: u,
    y: f
  };
}
function dt(e, t, n) {
  let o;
  if (t === "viewport")
    o = Rn(e, n);
  else if (t === "document")
    o = xn(ee(e));
  else if (W(t))
    o = bn(t, n);
  else {
    const r = Ot(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return ae(o);
}
function Mt(e, t) {
  const n = ne(e);
  return n === t || !W(n) || se(n) ? !1 : z(n).position === "fixed" || Mt(n, t);
}
function En(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = ie(e, [], !1).filter((c) => W(c) && de(c) !== "body"), r = null;
  const s = z(e).position === "fixed";
  let i = s ? ne(e) : e;
  for (; W(i) && !se(i); ) {
    const c = z(i), u = Ue(i);
    !u && c.position === "fixed" && (r = null), (s ? !u && !r : !u && c.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || we(i) && !u && Mt(e, i)) ? o = o.filter((d) => d !== i) : r = c, i = ne(i);
  }
  return t.set(e, o), o;
}
function Cn(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? Te(t) ? [] : En(t, this._c) : [].concat(n), o], c = i[0], u = i.reduce((f, d) => {
    const a = dt(t, d, r);
    return f.top = K(a.top, f.top), f.right = q(a.right, f.right), f.bottom = q(a.bottom, f.bottom), f.left = K(a.left, f.left), f;
  }, dt(t, c, r));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function An(e) {
  const {
    width: t,
    height: n
  } = Pt(e);
  return {
    width: t,
    height: n
  };
}
function Pn(e, t, n) {
  const o = Y(t), r = ee(t), s = n === "fixed", i = le(e, !0, s, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = Q(0);
  function f() {
    u.x = tt(r);
  }
  if (o || !o && !s)
    if ((de(t) !== "body" || we(r)) && (c = De(t)), o) {
      const l = le(t, !0, s, t);
      u.x = l.x + t.clientLeft, u.y = l.y + t.clientTop;
    } else r && f();
  s && !o && r && f();
  const d = r && !o && !s ? Tt(r, c) : Q(0), a = i.left + c.scrollLeft - u.x - d.x, m = i.top + c.scrollTop - u.y - d.y;
  return {
    x: a,
    y: m,
    width: i.width,
    height: i.height
  };
}
function ke(e) {
  return z(e).position === "static";
}
function mt(e, t) {
  if (!Y(e) || z(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ee(e) === n && (n = n.ownerDocument.body), n;
}
function Dt(e, t) {
  const n = j(e);
  if (Te(e))
    return n;
  if (!Y(e)) {
    let r = ne(e);
    for (; r && !se(r); ) {
      if (W(r) && !ke(r))
        return r;
      r = ne(r);
    }
    return n;
  }
  let o = mt(e, t);
  for (; o && Vt(o) && ke(o); )
    o = mt(o, t);
  return o && se(o) && ke(o) && !Ue(o) ? n : o || Kt(e) || n;
}
const On = function(e) {
  return U(this, null, function* () {
    const t = this.getOffsetParent || Dt, n = this.getDimensions, o = yield n(e.floating);
    return {
      reference: Pn(e.reference, yield t(e.floating), e.strategy),
      floating: {
        x: 0,
        y: 0,
        width: o.width,
        height: o.height
      }
    };
  });
};
function Tn(e) {
  return z(e).direction === "rtl";
}
const Mn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: wn,
  getDocumentElement: ee,
  getClippingRect: Cn,
  getOffsetParent: Dt,
  getElementRects: On,
  getClientRects: yn,
  getDimensions: An,
  getScale: fe,
  isElement: W,
  isRTL: Tn
};
function Lt(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Dn(e, t) {
  let n = null, o;
  const r = ee(e);
  function s() {
    var c;
    clearTimeout(o), (c = n) == null || c.disconnect(), n = null;
  }
  function i(c, u) {
    c === void 0 && (c = !1), u === void 0 && (u = 1), s();
    const f = e.getBoundingClientRect(), {
      left: d,
      top: a,
      width: m,
      height: l
    } = f;
    if (c || t(), !m || !l)
      return;
    const h = Re(a), g = Re(r.clientWidth - (d + m)), y = Re(r.clientHeight - (a + l)), v = Re(d), w = {
      rootMargin: -h + "px " + -g + "px " + -y + "px " + -v + "px",
      threshold: K(0, q(1, u)) || 1
    };
    let E = !0;
    function P(I) {
      const S = I[0].intersectionRatio;
      if (S !== u) {
        if (!E)
          return i();
        S ? i(!1, S) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !Lt(f, e.getBoundingClientRect()) && i(), E = !1;
    }
    try {
      n = new IntersectionObserver(P, F(C({}, w), {
        // Handle <iframe>s
        root: r.ownerDocument
      }));
    } catch (I) {
      n = new IntersectionObserver(P, w);
    }
    n.observe(e);
  }
  return i(!0), s;
}
function so(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = o, f = et(e), d = r || s ? [...f ? ie(f) : [], ...ie(t)] : [];
  d.forEach((v) => {
    r && v.addEventListener("scroll", n, {
      passive: !0
    }), s && v.addEventListener("resize", n);
  });
  const a = f && c ? Dn(f, n) : null;
  let m = -1, l = null;
  i && (l = new ResizeObserver((v) => {
    let [b] = v;
    b && b.target === f && l && (l.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var w;
      (w = l) == null || w.observe(t);
    })), n();
  }), f && !u && l.observe(f), l.observe(t));
  let h, g = u ? le(e) : null;
  u && y();
  function y() {
    const v = le(e);
    g && !Lt(g, v) && n(), g = v, h = requestAnimationFrame(y);
  }
  return n(), () => {
    var v;
    d.forEach((b) => {
      r && b.removeEventListener("scroll", n), s && b.removeEventListener("resize", n);
    }), a == null || a(), (v = l) == null || v.disconnect(), l = null, u && cancelAnimationFrame(h);
  };
}
const Ln = dn, Sn = mn, In = ln, kn = hn, gt = cn, Fn = fn, $n = gn, _n = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = C({
    platform: Mn
  }, n), s = F(C({}, r.platform), {
    _c: o
  });
  return sn(e, t, F(C({}, r), {
    platform: s
  }));
};
var Bn = typeof document != "undefined", Nn = function() {
}, be = Bn ? xt : Nn;
function Pe(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Pe(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const s = r[o];
      if (!(s === "_owner" && e.$$typeof) && !Pe(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function St(e) {
  return typeof window == "undefined" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ht(e, t) {
  const n = St(e);
  return Math.round(t * n) / n;
}
function Fe(e) {
  const t = p.useRef(e);
  return be(() => {
    t.current = e;
  }), t;
}
function Wn(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: c = !0,
    whileElementsMounted: u,
    open: f
  } = e, [d, a] = p.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, l] = p.useState(o);
  Pe(m, o) || l(o);
  const [h, g] = p.useState(null), [y, v] = p.useState(null), b = p.useCallback((x) => {
    x !== I.current && (I.current = x, g(x));
  }, []), w = p.useCallback((x) => {
    x !== S.current && (S.current = x, v(x));
  }, []), E = s || h, P = i || y, I = p.useRef(null), S = p.useRef(null), B = p.useRef(d), $ = u != null, H = Fe(u), L = Fe(r), N = Fe(f), k = p.useCallback(() => {
    if (!I.current || !S.current)
      return;
    const x = {
      placement: t,
      strategy: n,
      middleware: m
    };
    L.current && (x.platform = L.current), _n(I.current, S.current, x).then((R) => {
      const M = F(C({}, R), {
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: N.current !== !1
      });
      _.current && !Pe(B.current, M) && (B.current = M, Ht.flushSync(() => {
        a(M);
      }));
    });
  }, [m, t, n, L, N]);
  be(() => {
    f === !1 && B.current.isPositioned && (B.current.isPositioned = !1, a((x) => F(C({}, x), {
      isPositioned: !1
    })));
  }, [f]);
  const _ = p.useRef(!1);
  be(() => (_.current = !0, () => {
    _.current = !1;
  }), []), be(() => {
    if (E && (I.current = E), P && (S.current = P), E && P) {
      if (H.current)
        return H.current(E, P, k);
      k();
    }
  }, [E, P, k, H, $]);
  const O = p.useMemo(() => ({
    reference: I,
    floating: S,
    setReference: b,
    setFloating: w
  }), [b, w]), D = p.useMemo(() => ({
    reference: E,
    floating: P
  }), [E, P]), A = p.useMemo(() => {
    const x = {
      position: n,
      left: 0,
      top: 0
    };
    if (!D.floating)
      return x;
    const R = ht(D.floating, d.x), M = ht(D.floating, d.y);
    return c ? C(F(C({}, x), {
      transform: "translate(" + R + "px, " + M + "px)"
    }), St(D.floating) >= 1.5 && {
      willChange: "transform"
    }) : {
      position: n,
      left: R,
      top: M
    };
  }, [n, c, D.floating, d.x, d.y]);
  return p.useMemo(() => F(C({}, d), {
    update: k,
    refs: O,
    elements: D,
    floatingStyles: A
  }), [d, k, O, D, A]);
}
const Hn = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? gt({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? gt({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, co = (e, t) => F(C({}, Ln(e)), {
  options: [e, t]
}), lo = (e, t) => F(C({}, Sn(e)), {
  options: [e, t]
}), uo = (e, t) => F(C({}, $n(e)), {
  options: [e, t]
}), fo = (e, t) => F(C({}, In(e)), {
  options: [e, t]
}), ao = (e, t) => F(C({}, kn(e)), {
  options: [e, t]
}), mo = (e, t) => F(C({}, Fn(e)), {
  options: [e, t]
}), go = (e, t) => F(C({}, Hn(e)), {
  options: [e, t]
});
function ho(e) {
  return p.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  }, e);
}
const It = C({}, p), Vn = It.useInsertionEffect, Kn = Vn || ((e) => e());
function te(e) {
  const t = p.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Kn(() => {
    t.current = e;
  }), p.useCallback(function() {
    for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
      o[r] = arguments[r];
    return t.current == null ? void 0 : t.current(...o);
  }, []);
}
var Z = typeof document != "undefined" ? xt : Nt;
let pt = !1, jn = 0;
const vt = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + jn++
);
function Yn() {
  const [e, t] = p.useState(() => pt ? vt() : void 0);
  return Z(() => {
    e == null && t(vt());
  }, []), p.useEffect(() => {
    pt = !0;
  }, []), e;
}
const Xn = It.useId, kt = Xn || Yn;
let Xe;
process.env.NODE_ENV !== "production" && (Xe = /* @__PURE__ */ new Set());
function zn() {
  for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++)
    n[o] = arguments[o];
  const r = "Floating UI: " + n.join(" ");
  if (!((e = Xe) != null && e.has(r))) {
    var s;
    (s = Xe) == null || s.add(r), console.error(r);
  }
}
function Un() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var o;
      (o = e.get(t)) == null || o.forEach((r) => r(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var o;
      e.set(t, ((o = e.get(t)) == null ? void 0 : o.filter((r) => r !== n)) || []);
    }
  };
}
const Gn = /* @__PURE__ */ p.createContext(null), qn = /* @__PURE__ */ p.createContext(null), nt = () => {
  var e;
  return ((e = p.useContext(Gn)) == null ? void 0 : e.id) || null;
}, ot = () => p.useContext(qn);
function rt(e) {
  return "data-floating-ui-" + e;
}
function $e(e) {
  const t = Wt(e);
  return Z(() => {
    t.current = e;
  }), t;
}
const wt = /* @__PURE__ */ rt("safe-polygon");
function Ee(e, t, n) {
  return n && !Ke(n) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[t];
}
function po(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    dataRef: r,
    events: s,
    elements: i
  } = e, {
    enabled: c = !0,
    delay: u = 0,
    handleClose: f = null,
    mouseOnly: d = !1,
    restMs: a = 0,
    move: m = !0
  } = t, l = ot(), h = nt(), g = $e(f), y = $e(u), v = $e(n), b = p.useRef(), w = p.useRef(-1), E = p.useRef(), P = p.useRef(-1), I = p.useRef(!0), S = p.useRef(!1), B = p.useRef(() => {
  }), $ = p.useRef(!1), H = p.useCallback(() => {
    var A;
    const x = (A = r.current.openEvent) == null ? void 0 : A.type;
    return (x == null ? void 0 : x.includes("mouse")) && x !== "mousedown";
  }, [r]);
  p.useEffect(() => {
    if (!c) return;
    function A(x) {
      let {
        open: R
      } = x;
      R || (clearTimeout(w.current), clearTimeout(P.current), I.current = !0, $.current = !1);
    }
    return s.on("openchange", A), () => {
      s.off("openchange", A);
    };
  }, [c, s]), p.useEffect(() => {
    if (!c || !g.current || !n) return;
    function A(R) {
      H() && o(!1, R, "hover");
    }
    const x = ce(i.floating).documentElement;
    return x.addEventListener("mouseleave", A), () => {
      x.removeEventListener("mouseleave", A);
    };
  }, [i.floating, n, o, c, g, H]);
  const L = p.useCallback(function(A, x, R) {
    x === void 0 && (x = !0), R === void 0 && (R = "hover");
    const M = Ee(y.current, "close", b.current);
    M && !E.current ? (clearTimeout(w.current), w.current = window.setTimeout(() => o(!1, A, R), M)) : x && (clearTimeout(w.current), o(!1, A, R));
  }, [y, o]), N = te(() => {
    B.current(), E.current = void 0;
  }), k = te(() => {
    if (S.current) {
      const A = ce(i.floating).body;
      A.style.pointerEvents = "", A.removeAttribute(wt), S.current = !1;
    }
  }), _ = te(() => r.current.openEvent ? ["click", "mousedown"].includes(r.current.openEvent.type) : !1);
  p.useEffect(() => {
    if (!c) return;
    function A(T) {
      if (clearTimeout(w.current), I.current = !1, d && !Ke(b.current) || a > 0 && !Ee(y.current, "open"))
        return;
      const V = Ee(y.current, "open", b.current);
      V ? w.current = window.setTimeout(() => {
        v.current || o(!0, T, "hover");
      }, V) : n || o(!0, T, "hover");
    }
    function x(T) {
      if (_()) return;
      B.current();
      const V = ce(i.floating);
      if (clearTimeout(P.current), $.current = !1, g.current && r.current.floatingContext) {
        n || clearTimeout(w.current), E.current = g.current(F(C({}, r.current.floatingContext), {
          tree: l,
          x: T.clientX,
          y: T.clientY,
          onClose() {
            k(), N(), _() || L(T, !0, "safe-polygon");
          }
        }));
        const ye = E.current;
        V.addEventListener("mousemove", ye), B.current = () => {
          V.removeEventListener("mousemove", ye);
        };
        return;
      }
      (b.current === "touch" ? !ve(i.floating, T.relatedTarget) : !0) && L(T);
    }
    function R(T) {
      _() || r.current.floatingContext && (g.current == null || g.current(F(C({}, r.current.floatingContext), {
        tree: l,
        x: T.clientX,
        y: T.clientY,
        onClose() {
          k(), N(), _() || L(T);
        }
      }))(T));
    }
    if (W(i.domReference)) {
      var M;
      const T = i.domReference;
      return n && T.addEventListener("mouseleave", R), (M = i.floating) == null || M.addEventListener("mouseleave", R), m && T.addEventListener("mousemove", A, {
        once: !0
      }), T.addEventListener("mouseenter", A), T.addEventListener("mouseleave", x), () => {
        var V;
        n && T.removeEventListener("mouseleave", R), (V = i.floating) == null || V.removeEventListener("mouseleave", R), m && T.removeEventListener("mousemove", A), T.removeEventListener("mouseenter", A), T.removeEventListener("mouseleave", x);
      };
    }
  }, [i, c, e, d, a, m, L, N, k, o, n, v, l, y, g, r, _]), Z(() => {
    var A;
    if (c && n && (A = g.current) != null && A.__options.blockPointerEvents && H()) {
      S.current = !0;
      const R = i.floating;
      if (W(i.domReference) && R) {
        var x;
        const M = ce(i.floating).body;
        M.setAttribute(wt, "");
        const T = i.domReference, V = l == null || (x = l.nodesRef.current.find((ge) => ge.id === h)) == null || (x = x.context) == null ? void 0 : x.elements.floating;
        return V && (V.style.pointerEvents = ""), M.style.pointerEvents = "none", T.style.pointerEvents = "auto", R.style.pointerEvents = "auto", () => {
          M.style.pointerEvents = "", T.style.pointerEvents = "", R.style.pointerEvents = "";
        };
      }
    }
  }, [c, n, h, i, l, g, H]), Z(() => {
    n || (b.current = void 0, $.current = !1, N(), k());
  }, [n, N, k]), p.useEffect(() => () => {
    N(), clearTimeout(w.current), clearTimeout(P.current), k();
  }, [c, i.domReference, N, k]);
  const O = p.useMemo(() => {
    function A(x) {
      b.current = x.pointerType;
    }
    return {
      onPointerDown: A,
      onPointerEnter: A,
      onMouseMove(x) {
        const {
          nativeEvent: R
        } = x;
        function M() {
          !I.current && !v.current && o(!0, R, "hover");
        }
        d && !Ke(b.current) || n || a === 0 || $.current && Le(x.movementX, 2) + Le(x.movementY, 2) < 2 || (clearTimeout(P.current), b.current === "touch" ? M() : ($.current = !0, P.current = window.setTimeout(M, a)));
      }
    };
  }, [d, o, n, v, a]), D = p.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(w.current);
    },
    onMouseLeave(A) {
      _() || L(A.nativeEvent, !1);
    }
  }), [L, _]);
  return p.useMemo(() => c ? {
    reference: O,
    floating: D
  } : {}, [c, O, D]);
}
const ze = () => {
}, Ft = /* @__PURE__ */ p.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: ze,
  setState: ze,
  isInstantPhase: !1
}), Jn = () => p.useContext(Ft);
function vo(e) {
  const {
    children: t,
    delay: n,
    timeoutMs: o = 0
  } = e, [r, s] = p.useReducer((u, f) => C(C({}, u), f), {
    delay: n,
    timeoutMs: o,
    initialDelay: n,
    currentId: null,
    isInstantPhase: !1
  }), i = p.useRef(null), c = p.useCallback((u) => {
    s({
      currentId: u
    });
  }, []);
  return Z(() => {
    r.currentId ? i.current === null ? i.current = r.currentId : r.isInstantPhase || s({
      isInstantPhase: !0
    }) : (r.isInstantPhase && s({
      isInstantPhase: !1
    }), i.current = null);
  }, [r.currentId, r.isInstantPhase]), /* @__PURE__ */ p.createElement(Ft.Provider, {
    value: p.useMemo(() => F(C({}, r), {
      setState: s,
      setCurrentId: c
    }), [r, c])
  }, t);
}
function wo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    floatingId: r
  } = e, {
    id: s,
    enabled: i = !0
  } = t, c = s != null ? s : r, u = Jn(), {
    currentId: f,
    setCurrentId: d,
    initialDelay: a,
    setState: m,
    timeoutMs: l
  } = u;
  return Z(() => {
    i && f && (m({
      delay: {
        open: 1,
        close: Ee(a, "close")
      }
    }), f !== c && o(!1));
  }, [i, c, o, m, f, a]), Z(() => {
    function h() {
      o(!1), m({
        delay: a,
        currentId: null
      });
    }
    if (i && f && !n && f === c) {
      if (l) {
        const g = window.setTimeout(h, l);
        return () => {
          clearTimeout(g);
        };
      }
      h();
    }
  }, [i, n, m, f, c, o, a, l]), Z(() => {
    i && (d === ze || !n || d(c));
  }, [i, n, d, c]), u;
}
function _e(e, t) {
  let n = e.filter((r) => {
    var s;
    return r.parentId === t && ((s = r.context) == null ? void 0 : s.open);
  }), o = n;
  for (; o.length; )
    o = e.filter((r) => {
      var s;
      return (s = o) == null ? void 0 : s.some((i) => {
        var c;
        return r.parentId === i.id && ((c = r.context) == null ? void 0 : c.open);
      });
    }), n = n.concat(o);
  return n;
}
const Qn = "data-floating-ui-focusable", Zn = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, eo = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, yt = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function yo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    elements: r,
    dataRef: s
  } = e, {
    enabled: i = !0,
    escapeKey: c = !0,
    outsidePress: u = !0,
    outsidePressEvent: f = "pointerdown",
    referencePress: d = !1,
    referencePressEvent: a = "pointerdown",
    ancestorScroll: m = !1,
    bubbles: l,
    capture: h
  } = t, g = ot(), y = te(typeof u == "function" ? u : () => !1), v = typeof u == "function" ? y : u, b = p.useRef(!1), w = p.useRef(!1), {
    escapeKey: E,
    outsidePress: P
  } = yt(l), {
    escapeKey: I,
    outsidePress: S
  } = yt(h), B = p.useRef(!1), $ = te((O) => {
    var D;
    if (!n || !i || !c || O.key !== "Escape" || B.current)
      return;
    const A = (D = s.current.floatingContext) == null ? void 0 : D.nodeId, x = g ? _e(g.nodesRef.current, A) : [];
    if (!E && (O.stopPropagation(), x.length > 0)) {
      let R = !0;
      if (x.forEach((M) => {
        var T;
        if ((T = M.context) != null && T.open && !M.context.dataRef.current.__escapeKeyBubbles) {
          R = !1;
          return;
        }
      }), !R)
        return;
    }
    o(!1, Ut(O) ? O.nativeEvent : O, "escape-key");
  }), H = te((O) => {
    var D;
    const A = () => {
      var x;
      $(O), (x = ue(O)) == null || x.removeEventListener("keydown", A);
    };
    (D = ue(O)) == null || D.addEventListener("keydown", A);
  }), L = te((O) => {
    var D;
    const A = b.current;
    b.current = !1;
    const x = w.current;
    if (w.current = !1, f === "click" && x || A || typeof v == "function" && !v(O))
      return;
    const R = ue(O), M = "[" + rt("inert") + "]", T = ce(r.floating).querySelectorAll(M);
    let V = W(R) ? R : null;
    for (; V && !se(V); ) {
      const X = ne(V);
      if (se(X) || !W(X))
        break;
      V = X;
    }
    if (T.length && W(R) && !Gt(R) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !ve(R, r.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(T).every((X) => !ve(V, X)))
      return;
    if (Y(R) && _) {
      const X = R.clientWidth > 0 && R.scrollWidth > R.clientWidth, re = R.clientHeight > 0 && R.scrollHeight > R.clientHeight;
      let he = re && O.offsetX > R.clientWidth;
      if (re && z(R).direction === "rtl" && (he = O.offsetX <= R.offsetWidth - R.clientWidth), he || X && O.offsetY > R.clientHeight)
        return;
    }
    const ge = (D = s.current.floatingContext) == null ? void 0 : D.nodeId, ye = g && _e(g.nodesRef.current, ge).some((X) => {
      var re;
      return Ie(O, (re = X.context) == null ? void 0 : re.elements.floating);
    });
    if (Ie(O, r.floating) || Ie(O, r.domReference) || ye)
      return;
    const it = g ? _e(g.nodesRef.current, ge) : [];
    if (it.length > 0) {
      let X = !0;
      if (it.forEach((re) => {
        var he;
        if ((he = re.context) != null && he.open && !re.context.dataRef.current.__outsidePressBubbles) {
          X = !1;
          return;
        }
      }), !X)
        return;
    }
    o(!1, O, "outside-press");
  }), N = te((O) => {
    var D;
    const A = () => {
      var x;
      L(O), (x = ue(O)) == null || x.removeEventListener(f, A);
    };
    (D = ue(O)) == null || D.addEventListener(f, A);
  });
  p.useEffect(() => {
    if (!n || !i)
      return;
    s.current.__escapeKeyBubbles = E, s.current.__outsidePressBubbles = P;
    let O = -1;
    function D(T) {
      o(!1, T, "ancestor-scroll");
    }
    function A() {
      window.clearTimeout(O), B.current = !0;
    }
    function x() {
      O = window.setTimeout(
        () => {
          B.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Me() ? 5 : 0
      );
    }
    const R = ce(r.floating);
    c && (R.addEventListener("keydown", I ? H : $, I), R.addEventListener("compositionstart", A), R.addEventListener("compositionend", x)), v && R.addEventListener(f, S ? N : L, S);
    let M = [];
    return m && (W(r.domReference) && (M = ie(r.domReference)), W(r.floating) && (M = M.concat(ie(r.floating))), !W(r.reference) && r.reference && r.reference.contextElement && (M = M.concat(ie(r.reference.contextElement)))), M = M.filter((T) => {
      var V;
      return T !== ((V = R.defaultView) == null ? void 0 : V.visualViewport);
    }), M.forEach((T) => {
      T.addEventListener("scroll", D, {
        passive: !0
      });
    }), () => {
      c && (R.removeEventListener("keydown", I ? H : $, I), R.removeEventListener("compositionstart", A), R.removeEventListener("compositionend", x)), v && R.removeEventListener(f, S ? N : L, S), M.forEach((T) => {
        T.removeEventListener("scroll", D);
      }), window.clearTimeout(O);
    };
  }, [s, r, c, v, f, n, o, m, i, E, P, $, I, H, L, S, N]), p.useEffect(() => {
    b.current = !1;
  }, [v, f]);
  const k = p.useMemo(() => ({
    onKeyDown: $,
    [Zn[a]]: (O) => {
      d && o(!1, O.nativeEvent, "reference-press");
    }
  }), [$, o, d, a]), _ = p.useMemo(() => ({
    onKeyDown: $,
    onMouseDown() {
      w.current = !0;
    },
    onMouseUp() {
      w.current = !0;
    },
    [eo[f]]: () => {
      b.current = !0;
    }
  }), [$, f]);
  return p.useMemo(() => i ? {
    reference: k,
    floating: _
  } : {}, [i, k, _]);
}
function to(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: o
  } = e, r = kt(), s = p.useRef({}), [i] = p.useState(() => Un()), c = nt() != null;
  if (process.env.NODE_ENV !== "production") {
    const l = o.reference;
    l && !W(l) && zn("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [u, f] = p.useState(o.reference), d = te((l, h, g) => {
    s.current.openEvent = l ? h : void 0, i.emit("openchange", {
      open: l,
      event: h,
      reason: g,
      nested: c
    }), n == null || n(l, h, g);
  }), a = p.useMemo(() => ({
    setPositionReference: f
  }), []), m = p.useMemo(() => ({
    reference: u || o.reference || null,
    floating: o.floating || null,
    domReference: o.reference
  }), [u, o.reference, o.floating]);
  return p.useMemo(() => ({
    dataRef: s,
    open: t,
    onOpenChange: d,
    elements: m,
    events: i,
    floatingId: r,
    refs: a
  }), [t, d, m, i, r, a]);
}
function xo(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = to(F(C({}, e), {
    elements: C({
      reference: null,
      floating: null
    }, e.elements)
  })), o = e.rootContext || n, r = o.elements, [s, i] = p.useState(null), [c, u] = p.useState(null), d = (r == null ? void 0 : r.domReference) || s, a = p.useRef(null), m = ot();
  Z(() => {
    d && (a.current = d);
  }, [d]);
  const l = Wn(F(C({}, e), {
    elements: C(C({}, r), c && {
      reference: c
    })
  })), h = p.useCallback((w) => {
    const E = W(w) ? {
      getBoundingClientRect: () => w.getBoundingClientRect(),
      contextElement: w
    } : w;
    u(E), l.refs.setReference(E);
  }, [l.refs]), g = p.useCallback((w) => {
    (W(w) || w === null) && (a.current = w, i(w)), (W(l.refs.reference.current) || l.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    w !== null && !W(w)) && l.refs.setReference(w);
  }, [l.refs]), y = p.useMemo(() => F(C({}, l.refs), {
    setReference: g,
    setPositionReference: h,
    domReference: a
  }), [l.refs, g, h]), v = p.useMemo(() => F(C({}, l.elements), {
    domReference: d
  }), [l.elements, d]), b = p.useMemo(() => F(C(C({}, l), o), {
    refs: y,
    elements: v,
    nodeId: t
  }), [l, y, v, t, o]);
  return Z(() => {
    o.dataRef.current.floatingContext = b;
    const w = m == null ? void 0 : m.nodesRef.current.find((E) => E.id === t);
    w && (w.context = b);
  }), p.useMemo(() => F(C({}, l), {
    context: b,
    refs: y,
    elements: v
  }), [l, y, v, b]);
}
function Ro(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    events: r,
    dataRef: s,
    elements: i
  } = e, {
    enabled: c = !0,
    visibleOnly: u = !0
  } = t, f = p.useRef(!1), d = p.useRef(), a = p.useRef(!0);
  p.useEffect(() => {
    if (!c) return;
    const l = j(i.domReference);
    function h() {
      !n && Y(i.domReference) && i.domReference === ut(ce(i.domReference)) && (f.current = !0);
    }
    function g() {
      a.current = !0;
    }
    return l.addEventListener("blur", h), l.addEventListener("keydown", g, !0), () => {
      l.removeEventListener("blur", h), l.removeEventListener("keydown", g, !0);
    };
  }, [i.domReference, n, c]), p.useEffect(() => {
    if (!c) return;
    function l(h) {
      let {
        reason: g
      } = h;
      (g === "reference-press" || g === "escape-key") && (f.current = !0);
    }
    return r.on("openchange", l), () => {
      r.off("openchange", l);
    };
  }, [r, c]), p.useEffect(() => () => {
    clearTimeout(d.current);
  }, []);
  const m = p.useMemo(() => ({
    onPointerDown(l) {
      jt(l.nativeEvent) || (a.current = !1);
    },
    onMouseLeave() {
      f.current = !1;
    },
    onFocus(l) {
      if (f.current) return;
      const h = ue(l.nativeEvent);
      if (u && W(h))
        try {
          if (Yt() && Xt()) throw Error();
          if (!h.matches(":focus-visible")) return;
        } catch (g) {
          if (!a.current && !Jt(h))
            return;
        }
      o(!0, l.nativeEvent, "focus");
    },
    onBlur(l) {
      f.current = !1;
      const h = l.relatedTarget, g = l.nativeEvent, y = W(h) && h.hasAttribute(rt("focus-guard")) && h.getAttribute("data-type") === "outside";
      d.current = window.setTimeout(() => {
        var v;
        const b = ut(i.domReference ? i.domReference.ownerDocument : document);
        !h && b === i.domReference || ve((v = s.current.floatingContext) == null ? void 0 : v.refs.floating.current, b) || ve(i.domReference, b) || y || o(!1, g, "focus");
      });
    }
  }), [s, i.domReference, o, u]);
  return p.useMemo(() => c ? {
    reference: m
  } : {}, [c, m]);
}
const Be = "active", Ne = "selected";
function We(e, t, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item";
  let s = e;
  if (r && e) {
    const i = e, {
      [Be]: c,
      [Ne]: u
    } = i;
    s = pe(i, [
      Se(Be),
      Se(Ne)
    ]);
  }
  return C(C(C({}, n === "floating" && {
    tabIndex: -1,
    [Qn]: ""
  }), s), t.map((c) => {
    const u = c ? c[n] : null;
    return typeof u == "function" ? e ? u(e) : null : u;
  }).concat(e).reduce((c, u) => (u && Object.entries(u).forEach((f) => {
    let [d, a] = f;
    if (!(r && [Be, Ne].includes(d)))
      if (d.indexOf("on") === 0) {
        if (o.has(d) || o.set(d, []), typeof a == "function") {
          var m;
          (m = o.get(d)) == null || m.push(a), c[d] = function() {
            for (var l, h = arguments.length, g = new Array(h), y = 0; y < h; y++)
              g[y] = arguments[y];
            return (l = o.get(d)) == null ? void 0 : l.map((v) => v(...g)).find((v) => v !== void 0);
          };
        }
      } else
        c[d] = a;
  }), c), {}));
}
function bo(e) {
  e === void 0 && (e = []);
  const t = e.map((c) => c == null ? void 0 : c.reference), n = e.map((c) => c == null ? void 0 : c.floating), o = e.map((c) => c == null ? void 0 : c.item), r = p.useCallback(
    (c) => We(c, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), s = p.useCallback(
    (c) => We(c, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), i = p.useCallback(
    (c) => We(c, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  );
  return p.useMemo(() => ({
    getReferenceProps: r,
    getFloatingProps: s,
    getItemProps: i
  }), [r, s, i]);
}
const no = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function Eo(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    open: o,
    floatingId: r
  } = e, {
    enabled: s = !0,
    role: i = "dialog"
  } = t, c = (n = no.get(i)) != null ? n : i, u = kt(), d = nt() != null, a = p.useMemo(() => c === "tooltip" || i === "label" ? {
    ["aria-" + (i === "label" ? "labelledby" : "describedby")]: o ? r : void 0
  } : C(C(C(C(C({
    "aria-expanded": o ? "true" : "false",
    "aria-haspopup": c === "alertdialog" ? "dialog" : c,
    "aria-controls": o ? r : void 0
  }, c === "listbox" && {
    role: "combobox"
  }), c === "menu" && {
    id: u
  }), c === "menu" && d && {
    role: "menuitem"
  }), i === "select" && {
    "aria-autocomplete": "none"
  }), i === "combobox" && {
    "aria-autocomplete": "list"
  }), [c, r, d, o, u, i]), m = p.useMemo(() => {
    const h = C({
      id: r
    }, c && {
      role: c
    });
    return c === "tooltip" || i === "label" ? h : C(C({}, h), c === "menu" && {
      "aria-labelledby": u
    });
  }, [c, r, u, i]), l = p.useCallback((h) => {
    let {
      active: g,
      selected: y
    } = h;
    const v = C({
      role: "option"
    }, g && {
      id: r + "-option"
    });
    switch (i) {
      case "select":
        return F(C({}, v), {
          "aria-selected": g && y
        });
      case "combobox":
        return C(C({}, v), g && {
          "aria-selected": !0
        });
    }
    return {};
  }, [r, i]);
  return p.useMemo(() => s ? {
    reference: a,
    floating: m,
    item: l
  } : {}, [s, a, m, l]);
}
export {
  vo as F,
  so as a,
  go as b,
  ao as c,
  wo as d,
  bo as e,
  fo as f,
  ie as g,
  po as h,
  mo as i,
  Ro as j,
  Eo as k,
  uo as l,
  yo as m,
  ho as n,
  co as o,
  lo as s,
  xo as u
};
